import LAYOUT from '@/layouts/default/index.vue';

export default {
  path: '/feedback',
  component: LAYOUT,
  name: 'feedback',
  redirect: '/feedback/index',
  meta: {
    title: '意见反馈',
  },
  children: [
    {
      path: 'index',
      name: 'FeedbackIndex',
      meta: {
        title: '意见反馈',
        keepAlive: true,
      },
      component: () => import('@/views/feedback/index.vue'),
    },
    {
      path: 'records',
      name: 'FeedbackRecords',
      meta: {
        title: '意见反馈',
        keepAlive: true,
      },
      component: () => import('@/views/feedback/records.vue'),
    },
    {
      path: 'detail',
      name: 'FeedbackDetail',
      meta: {
        title: '反馈详情',
      },
      component: () => import('@/views/feedback/detail.vue'),
    },
  ],

};
